export default __webpack_public_path__ + "static/media/Banner-resena-1-agenda.f05bb201.jpg";